import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';

import { EstudiosService } from '../../../core/services/estudios.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-estudios-solicitados-dialog',
  imports: [
    MatStepperModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogActions,
    MatDialogContent,
  ],
  templateUrl: './estudios-solicitados-dialog.html',
  styleUrl: './estudios-solicitados-dialog.scss',
})
export class EstudiosSolicitadosDialog {
  constructor(
    private dialogRef: MatDialogRef<EstudiosSolicitadosDialog>,
    private estudiosService: EstudiosService,

    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) {}

  private fb = new FormBuilder();

  form = this.fb.group({
    nombre: [''],
    indicaciones: [''],
  });

  ngOnInit(): void {
    // EDITAR ESTUDIO
    if (this.data?.estudio) {
      this.form.patchValue({
        nombre: this.data.estudio.nombre ?? '',
        indicaciones: this.data.estudio.indicaciones ?? '',
      });
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const valores = this.form.getRawValue();

    // console.log('VALORES DEL FORMULARIO:', valores);

    // ============================================
    // EDITAR ESTUDIO
    // ============================================

    if (this.data?.estudio?.id) {
      const estudioId = this.data.estudio.id;

      const payload = {
        nombre: valores.nombre ?? '',
        indicaciones: valores.indicaciones ?? '',
      };

      // console.log('EDITANDO ESTUDIO:', estudioId);
      // console.log('PAYLOAD:', payload);

      this.estudiosService.actualizarEstudio(estudioId, payload).subscribe({
        next: (respuesta) => {
          Swal.fire({
            icon: 'success',
            title: 'Estudio actualizado',
            text: 'Las indicaciones fueron actualizadas correctamente.',
            confirmButtonColor: '#24575A',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            // console.log('Respuesta del backend:', respuesta);

            this.dialogRef.close(respuesta?.data ?? respuesta);
          });
        },

        error: (error) => {
          // console.error('Error al actualizar el estudio:', error);

          Swal.fire({
            icon: 'error',
            title: 'No se pudo actualizar',
            text: error?.error?.message ?? 'Ocurrió un error al actualizar el estudio.',
            showConfirmButton: false,
            timer: 2000,
          });
        },
      });

      return;
    }

    // ============================================
    // CREAR ESTUDIO
    // ============================================

    const atencionId = this.data?.atencionId;

    if (!atencionId) {
      // console.error('No se recibió el atencionId');

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se encontró el ID de la atención.',
        showConfirmButton: false,
        timer: 2000,
      });

      return;
    }

    const payload = {
      nombre: valores.nombre ?? '',
      indicaciones: valores.indicaciones ?? '',
    };

    // console.log('CREANDO NUEVO ESTUDIO');
    // console.log('ATENCION ID:', atencionId);
    // console.log('PAYLOAD:', payload);

    this.estudiosService.generarEstudio(atencionId, payload).subscribe({
      next: (respuesta) => {
        Swal.fire({
          icon: 'success',
          title: 'Registro exitoso',
          text: 'El estudio fue agregado correctamente.',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          // console.log('Respuesta del backend:', respuesta);

          this.dialogRef.close(respuesta?.data ?? respuesta);
        });
      },

      error: (error) => {
        // console.error('Error al agregar el estudio:', error);

        Swal.fire({
          icon: 'error',
          title: 'No se pudo agregar',
          text: error?.error?.message ?? 'Ocurrió un error al guardar el estudio.',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }
}
